import React from 'react';
import {
  LuTarget,
  LuUsers,
  LuTrendingUp,
  LuShieldCheck,
  LuCalendarCheck,
  LuChevronRight,
  LuClipboardCheck,
  LuSearch,
  LuFileText,
  LuChartBar,
} from 'react-icons/lu';

// Konstanta WhatsApp
const WA_NUMBER = '6282337289588';
const WA_MESSAGE = 'Halo%20SriDesain%2C%20saya%20tertarik%20untuk%20konsultasi%20strategi%20iklan%20gratis';

const FEATURES = [
  { icon: LuTarget, label: 'Strategi\nTerbukti' },
  { icon: LuUsers, label: 'Lebih Banyak\nCustomer' },
  { icon: LuTrendingUp, label: 'Hasil Terukur\n& Optimal' },
  { icon: LuShieldCheck, label: 'Aman &\nTerpercaya' },
];

const BOTTOM_STRIP = [
  { icon: LuClipboardCheck, label: 'Analisis Kebutuhan\nBisnis Anda' },
  { icon: LuSearch, label: 'Rekomendasi Strategi\nyang Tepat' },
  { icon: LuFileText, label: 'Rencana Iklan\nyang Efektif' },
  { icon: LuChartBar, label: 'Optimasi untuk\nHasil Maksimal' },
];

const Section10 = () => {
  return (
    <section className="relative overflow-hidden bg-white py-16 lg:py-20">
      {/* Ambient glow, consistent with other sections */}
      <div className="pointer-events-none absolute -top-40 right-0 h-[600px] w-[600px] rounded-full bg-amber-100/60 blur-3xl" />
      <div className="pointer-events-none absolute bottom-0 left-1/4 h-[400px] w-[400px] rounded-full bg-slate-100/70 blur-3xl" />

      <div className="relative mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-[1.15fr_1fr] lg:gap-14">
          {/* Left: copy */}
          <div>
            <h2 className="font-[var(--font-display)] text-3xl font-extrabold leading-[1.08] tracking-tight text-[#0F172A] sm:text-4xl xl:text-[2.75rem]">
              Jangan Biarkan
              <br />
              Budget Iklan
              <br />
              <span className="text-amber-600">Terus Habis</span>
              <br />
              <span className="relative inline-block">
                <span
                  className="absolute inset-x-0 bottom-1 h-[0.7em] bg-amber-400"
                  style={{ clipPath: 'polygon(0% 15%, 100% 0%, 99% 90%, 1% 100%)' }}
                />
                <span className="relative px-1 text-[#0F172A]">Tanpa Hasil.</span>
              </span>
            </h2>

            <div className="mt-6 border-l-4 border-[#0F172A] pl-4">
              <p className="text-base leading-relaxed text-slate-600 sm:text-lg">
                Saatnya Gunakan{' '}
                <span className="font-bold text-amber-600">Strategi yang Terbukti</span>{' '}
                Membantu Bisnis Mendapatkan Lebih Banyak{' '}
                <span className="font-bold text-[#0F172A]">Customer.</span>
              </p>
            </div>

            {/* Feature icons row */}
            <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-4">
              {FEATURES.map(({ icon: Icon, label }) => (
                <div key={label} className="flex flex-col items-center gap-2 text-center">
                  <span className="flex h-14 w-14 items-center justify-center rounded-full border-2 border-amber-400 bg-amber-50 text-amber-600">
                    <Icon className="h-6 w-6" />
                  </span>
                  <p className="whitespace-pre-line text-xs font-semibold leading-tight text-[#0F172A]">
                    {label}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Right: visual */}
          <div className="relative mx-auto w-full max-w-sm lg:max-w-none">
            <div className="pointer-events-none absolute -inset-6 rounded-[2.5rem] bg-gradient-to-br from-amber-100/70 via-orange-50/40 to-transparent blur-2xl" />

            {/* decorative growth arrow */}
            <svg
              viewBox="0 0 300 260"
              className="pointer-events-none absolute -right-4 top-0 h-40 w-40 opacity-90 sm:h-52 sm:w-52"
              fill="none"
            >
              <polyline
                points="10,240 70,190 130,210 190,110 250,60"
                stroke="#C9A227"
                strokeWidth="10"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
              />
              <path d="M215,40 L265,55 L250,105 Z" fill="#C9A227" />
            </svg>

            <div className="relative aspect-[4/4.4] w-full overflow-hidden rounded-[2rem]">
              <img
                src="/hero4.png"
                alt="Klien SriDesain semangat dengan hasil campaign iklan"
                className="h-full w-full object-cover"
                style={{
                  maskImage:
                    'radial-gradient(ellipse 100% 100% at center, black 62%, transparent 100%)',
                  WebkitMaskImage:
                    'radial-gradient(ellipse 100% 100% at center, black 62%, transparent 100%)',
                }}
              />
            </div>

            {/* Sales stat card */}
            <div className="absolute left-0 top-10 w-32 rounded-xl border border-slate-100/80 bg-white/95 px-3 py-2.5 shadow-lg shadow-slate-200/50 backdrop-blur-sm">
              <p className="text-[10px] font-medium text-slate-500">Sales</p>
              <p className="mt-0.5 text-xl font-extrabold text-amber-600">+250%</p>
              <p className="text-[9px] text-slate-400">vs last month</p>
              <svg viewBox="0 0 100 30" className="mt-1 h-6 w-full">
                <polyline
                  fill="none"
                  stroke="#16A34A"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  points="0,26 15,20 30,22 45,12 60,14 75,6 100,2"
                />
              </svg>
            </div>
          </div>
        </div>

        {/* CTA button - full width below the grid */}
         <a
          href={`https://wa.me/${WA_NUMBER}?text=${WA_MESSAGE}`}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-10 flex w-full items-center gap-4 rounded-full bg-amber-400 py-2 pl-2 pr-3 shadow-lg shadow-amber-300/50 transition hover:bg-amber-500 hover:scale-[1.02]"
        >
          <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[#0F172A] text-amber-400">
            <LuCalendarCheck className="h-5 w-5" />
          </span>
          <span className="flex-1 text-center text-sm font-extrabold uppercase tracking-wide text-[#0F172A] sm:text-base">
            Konsultasi Strategi Iklan Gratis
          </span>
          <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#0F172A] text-amber-400">
            <LuChevronRight className="h-5 w-5" />
          </span>
        </a>

        {/* Bottom strip - full width below the CTA */}
        <div className="mt-6 grid grid-cols-2 gap-4 rounded-2xl border border-slate-100 bg-white px-5 py-4 shadow-sm shadow-slate-200/40 sm:grid-cols-4">
          {BOTTOM_STRIP.map(({ icon: Icon, label }) => (
            <div key={label} className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-amber-50 text-amber-600">
                <Icon className="h-4 w-4" />
              </span>
              <p className="whitespace-pre-line text-[11px] font-semibold leading-tight text-[#0F172A]">
                {label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Section10;